import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  id: "couponPrint",
  class: "row coupon-wrapper no-gutters"
}
const _hoisted_3 = { class: "col col-12 col-md-10 offset-md-1" }
const _hoisted_4 = { class: "card my-2" }
const _hoisted_5 = {
  class: "container",
  style: {}
}
const _hoisted_6 = { class: "row no-gutters px-4 py-4 align-items-end" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = {
  class: "h1 card-title",
  style: {"color":"var(--primary-color)","font-weight":"bold"}
}
const _hoisted_9 = { class: "" }
const _hoisted_10 = {
  class: "p-3 mb-3 border rounded",
  style: {"background-color":"var(--background-color-light)"}
}
const _hoisted_11 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_back_to_previous_page = _resolveComponent("back-to-previous-page")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["alert alert-success alert-dismissible mail-alert", { 'show-alert': _ctx.mailSent || _ctx.smsSent }])
    }, [
      _createVNode(_component_router_link, {
        to: "#",
        class: "btn-close",
        onClick: _ctx.closeAlert
      }, null, 8, ["onClick"]),
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "notification-text" }, "Message sent.", -1))
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["alert alert-danger alert-dismissible mail-alert", { 'show-alert': _ctx.mailSendFailure || _ctx.smsSendFailure }])
    }, [
      _createVNode(_component_router_link, {
        to: "#",
        class: "btn-close text-dark",
        onClick: _ctx.closeAlert
      }, null, 8, ["onClick"]),
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "danger-text" }, "Failed to send message.", -1))
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_back_to_previous_page, {
        class: "col-12 col-md-10 offset-md-1",
        returnURL: _ctx.returnURL,
        backText: "Back to Search Results"
      }, null, 8, ["returnURL"]),
      _cache[9] || (_cache[9] = _createElementVNode("h1", { class: "h2 col-12 col-md-10 offset-md-1 text-center" }, [
        _createElementVNode("b", { class: "lead" }, "Acquire a manufacturer coupon and show it to your pharmacy to save")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.manufacturerCoupon.drugName) + " Manufacturer Coupon ", 1),
                _createElementVNode("p", null, [
                  _createElementVNode("b", null, "You can't apply for a " + _toDisplayString(_ctx.manufacturerCoupon.drugName) + " Manufacturer Coupon on IntelligentRx.com. Please use an alternative option:", 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "h5" }, "Self-Service: Visit Manufacturer's Website", -1)),
                    _createElementVNode("p", null, "Navigate " + _toDisplayString(_ctx.manufacturerCoupon.drugName) + "'s website to apply for a manufacturer coupon / copay assistance / patient assistance program.", 1),
                    _createElementVNode("p", null, [
                      _createElementVNode("a", {
                        class: "btn irx-btn-primary irx-btn-primary-animated w-100 btn-lg",
                        href: _ctx.manufacturerCoupon.manufacturerURL
                      }, " Go To " + _toDisplayString(_ctx.manufacturerCoupon.drugName) + "'s Website ", 9, _hoisted_11)
                    ])
                  ]),
                  _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"p-3 mb-3 border rounded\" style=\"background-color:var(--background-color-light);\" data-v-5c194094><h3 class=\"h5\" data-v-5c194094>Enroll Via Prescription Hope</h3><p data-v-5c194094>Enroll for $60 / Month in Prescription Hope to pay $0 / month on your copay. Restrictions on income and insurance type apply.</p><p data-v-5c194094><a class=\"btn irx-btn-primary irx-btn-primary-animated w-100 btn-lg\" href=\"https://prescriptionhope.com/\" data-v-5c194094> Prescription Hope </a></p></div><div class=\"p-3 mb-3 border rounded\" style=\"background-color:var(--background-color-light);\" data-v-5c194094><h3 class=\"h5\" data-v-5c194094>Call IntelligentRx For Help</h3><p data-v-5c194094><a class=\"btn irx-btn-primary irx-btn-primary-animated w-100 btn-lg\" href=\"tel:1-800-484-3487\" data-v-5c194094> 1-800-484-3487 </a></p></div>", 2))
                ]),
                _cache[4] || (_cache[4] = _createElementVNode("hr", null, null, -1)),
                _cache[5] || (_cache[5] = _createElementVNode("h2", {
                  class: "h1 card-title",
                  style: {"color":"var(--primary-color)","font-weight":"bold"}
                }, " Manufacturer Coupon FAQ ", -1)),
                _cache[6] || (_cache[6] = _createElementVNode("p", null, [
                  _createElementVNode("b", null, "What is a manufacturer coupon?"),
                  _createTextVNode(" It is a coupon-like discount on a prescription medication which can be redeemed at your pharmacy. The coupon lowers a patient's out of pocket cost.")
                ], -1)),
                _cache[7] || (_cache[7] = _createElementVNode("p", null, [
                  _createElementVNode("b", null, "Who can use a manufacturer coupon?"),
                  _createTextVNode(" It depends. Usually only commercially-insured patients can use them. This means you can't use them if you receive health insurance via a federal or state program like Medicare, Medicaid, TRICARE, Department of Defense, or Veterans Administration. These programs are usually excluded because the program may violate federal anti-kickback laws. Additional restrictions may apply. The eligibility requirements vary on a product-by-product basis.")
                ], -1)),
                _cache[8] || (_cache[8] = _createElementVNode("p", null, [
                  _createElementVNode("b", null, "Why do manufacturers give away their products?"),
                  _createTextVNode(" Manufacturers still make money when you use a manufacturer coupon because they continue to bill your insurance company for their portion of the bill - without a discount. Manufacturers reduce patient's bills because "),
                  _createElementVNode("a", { href: "https://www.iqvia.com/insights/the-iqvia-institute/reports-and-publications/reports/medicine-spending-and-affordability-in-the-us#:~:text=A%20growing%20public%20health%20concern%20is%20patients%20abandoning%20their%20new%20prescriptions%20and%20not%20following%20a%20physician%E2%80%99s%20recommendation%20for%20care.%20Abandonment%20occurs%20much%20more%20often%20when%20patient%E2%80%99s%20have%20higher%20out%2Dof%2Dpocket%20cost." }, "higher out-of-pocket patient costs cause much higher abandonment rates"),
                  _createTextVNode(", and if you abandon a medication then they get paid nothing. Manufacturer's thinking seems to be: it's better to get paid something than to get nothing.")
                ], -1))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}